import { trackingDataApis, TrackingDataBody } from '@apis/dashboard/trackingDataApis';
import { useMutation } from '@hooks/useMutation';
import { useQueryClient } from '@tanstack/react-query';

export const usePatchTrackingData = (trackNo: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: TrackingDataBody) => {
      const response = await trackingDataApis.patch('/dashboard/tracking-data/{track_no}/', {
        path: {
          track_no: trackNo,
        },
        body,
      });
      return response[200];
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['/tracking-data/', trackNo]);
        queryClient.invalidateQueries(['/dashboard/tracking-data/', trackNo]);
      },
    },
  );
};
